"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var constants_1 = __importDefault(require("../../../config/constants"));
var isBrowser = typeof window !== 'undefined';
var isLoaded = function () { return isBrowser && typeof window.grecaptcha !== 'undefined'; };
var isReady = function () { return isLoaded() && typeof window.grecaptcha.execute === 'function'; };
var scriptId = 'google-recaptcha-script-tag';
var ReCaptcha = (function (_super) {
    __extends(ReCaptcha, _super);
    function ReCaptcha(props) {
        var _this = _super.call(this, props) || this;
        _this.readyCheck = null;
        _this.componentDidMount = function () { return __awaiter(_this, void 0, void 0, function () {
            var badge, scriptID;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        badge = document.getElementsByClassName('grecaptcha-badge');
                        if (!(!!badge && badge.length > 0)) return [3, 2];
                        badge[0].style.visibility = 'visible';
                        if (isBrowser) {
                            this.readyCheck = this.state.isReady
                                ? null
                                : window.setInterval(this.updateReadyState, isLoaded() ? 0 : 1000);
                        }
                        return [4, this.setup()];
                    case 1:
                        _a.sent();
                        return [3, 5];
                    case 2: return [4, this.loadScript()];
                    case 3:
                        scriptID = _a.sent();
                        if (!(scriptID === this.state.scriptId)) return [3, 5];
                        if (isBrowser) {
                            this.readyCheck = this.state.isReady
                                ? null
                                : window.setInterval(this.updateReadyState, isLoaded() ? 0 : 1000);
                        }
                        return [4, this.setup()];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5: return [2];
                }
            });
        }); };
        _this.componentWillUnmount = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.readyCheck) {
                            clearInterval(this.readyCheck);
                        }
                        this.readyCheck = null;
                        return [4, this.removeScript()];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        }); };
        _this.loadScript = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2, new Promise(function (resolve, reject) {
                        var script = document.createElement('script');
                        script.src = "https://www.google.com/recaptcha/api.js?render=".concat(_this.state.key);
                        script.id = _this.state.scriptId;
                        script.async = true;
                        script.onload = function () {
                            resolve(_this.state.scriptId);
                        };
                        script.onerror = function (e) {
                            reject(e);
                        };
                        document.body.appendChild(script);
                    })];
            });
        }); };
        _this.removeScript = function () { return __awaiter(_this, void 0, void 0, function () {
            var badge;
            return __generator(this, function (_a) {
                badge = document.getElementsByClassName('grecaptcha-badge');
                if (!!badge && badge.length > 0) {
                    badge[0].style.visibility = 'hidden';
                }
                return [2];
            });
        }); };
        _this.setup = function () { return __awaiter(_this, void 0, void 0, function () {
            var token;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.state.isReady) return [3, 2];
                        return [4, window.grecaptcha.execute(this.state.key, { action: this.props.action })];
                    case 1:
                        token = _a.sent();
                        if (!!token && !!this.props.onChange) {
                            this.props.onChange(token);
                        }
                        _a.label = 2;
                    case 2: return [2];
                }
            });
        }); };
        _this.setReady = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setState({ isReady: true });
                        return [4, this.setup()];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        }); };
        _this.updateReadyState = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (isLoaded()) {
                    window.grecaptcha.ready(this.setReady);
                    if (this.readyCheck) {
                        clearInterval(this.readyCheck);
                        this.readyCheck = null;
                    }
                }
                return [2];
            });
        }); };
        _this.state = {
            scriptId: scriptId,
            key: constants_1.default.GOOGLE_RECAPTCHA_SITE_KEY,
            isReady: isReady()
        };
        return _this;
    }
    ReCaptcha.prototype.render = function () {
        return null;
    };
    return ReCaptcha;
}(react_1.default.Component));
exports.default = ReCaptcha;
//# sourceMappingURL=ReCaptcha.js.map